import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const About: React.FC = () => {
  const { t } = useTranslation();
  const [discordData, setDiscordData] = useState<any>(null);

  useEffect(() => {
    fetch('https://discord.com/api/guilds/1336643382860058696/widget.json')
      .then((res) => res.json())
      .then((data) => setDiscordData(data))
      .catch((err) => console.error('Chyba načítání Discord API', err));
  }, []);

  return (
    <Container className="py-5">
      <Row>
        <Col>
          <h2 className="about-title">{t('about.title')}</h2>
          <p className="about-description">
            {t('about.description')}{' '}
            <a
              href="https://octopodsystems.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              OctopodSystems.com
            </a>
          </p>
          <Row className="community-container d-flex justify-content-center align-items-stretch gap-3">
            <Col md={5} className="d-flex">
              <div className="discord-container flex-grow-1 text-center p-4">
                <h3>{t('features.discord.title')}</h3>
                {discordData ? (
                  <>
                    <h3>{discordData.name}</h3>
                    <p>
                      👥 {t('features.discord.onlineMembers')}:{' '}
                      {discordData.presence_count}
                    </p>
                    <a
                      href={discordData.instant_invite}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="community-join-button discord-button w-100 text-center p-3"
                    >
                      {t('features.discord.join')}
                    </a>
                  </>
                ) : (
                  <p>{t('features.discord.loading')}</p>
                )}
              </div>
            </Col>
            <Col md={5} className="d-flex">
              <div className="reddit-container flex-grow-1 text-center p-4">
                <h3>{t('features.reddit.title')}</h3>
                <p>{t('features.reddit.description')}</p>
                <a
                  href="https://www.reddit.com/r/CheckChecker/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="community-join-button reddit-button w-100 text-center p-3"
                >
                  {t('features.reddit.join')}
                </a>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

export default About;
